export enum Tools {
  CURSOR, RECTANGLE, CIRCLE, POLYGON
}